var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Config_instances, _Config_observer, _Config_locale, _Config_theme, _Config_featureFlags, _Config_getLocale;
const KEY_LOCALE = 'locale';
const KEY_THEME = 'theme';
const DEFAULT_LOCALE = 'en-GB';
export const ALLOWED_LOCALES = [
    'en-GB',
    'en-US',
    'nl-NL',
    'es-ES',
    'hu-HU',
    'tr-TR',
    'el-GR',
    'sk-SK',
    'ro-RO',
    'fr-BE',
    'cs-CZ',
];
class Config {
    constructor(observer, featureFlags) {
        _Config_instances.add(this);
        _Config_observer.set(this, void 0);
        _Config_locale.set(this, void 0);
        _Config_theme.set(this, void 0);
        _Config_featureFlags.set(this, void 0);
        __classPrivateFieldSet(this, _Config_observer, observer, "f");
        __classPrivateFieldSet(this, _Config_locale, __classPrivateFieldGet(this, _Config_instances, "m", _Config_getLocale).call(this), "f");
        __classPrivateFieldSet(this, _Config_theme, 'Light', "f");
        __classPrivateFieldSet(this, _Config_featureFlags, featureFlags, "f");
    }
    getLocale() {
        return __classPrivateFieldGet(this, _Config_locale, "f");
    }
    getTheme() {
        return __classPrivateFieldGet(this, _Config_theme, "f");
    }
    getFeatureFlags() {
        return __classPrivateFieldGet(this, _Config_featureFlags, "f");
    }
    setLocale(value) {
        if (value !== __classPrivateFieldGet(this, _Config_locale, "f")) {
            __classPrivateFieldSet(this, _Config_locale, value, "f");
            __classPrivateFieldGet(this, _Config_observer, "f").publish(KEY_LOCALE, value);
        }
        return this;
    }
    setTheme(value) {
        if (value !== __classPrivateFieldGet(this, _Config_theme, "f")) {
            __classPrivateFieldSet(this, _Config_theme, value, "f");
            __classPrivateFieldGet(this, _Config_observer, "f").publish(KEY_THEME, value);
        }
        return this;
    }
    subscribeToLocaleChange(handler) {
        __classPrivateFieldGet(this, _Config_observer, "f").subscribe(KEY_LOCALE, handler);
        return this;
    }
    subscribeToThemeChange(handler) {
        __classPrivateFieldGet(this, _Config_observer, "f").subscribe(KEY_THEME, handler);
        return this;
    }
    unsubscribeFromLocaleChange(handler) {
        __classPrivateFieldGet(this, _Config_observer, "f").unsubscribe(KEY_LOCALE, handler);
        return this;
    }
    unsubscribeFromThemeChange(handler) {
        __classPrivateFieldGet(this, _Config_observer, "f").unsubscribe(KEY_THEME, handler);
        return this;
    }
}
_Config_observer = new WeakMap(), _Config_locale = new WeakMap(), _Config_theme = new WeakMap(), _Config_featureFlags = new WeakMap(), _Config_instances = new WeakSet(), _Config_getLocale = function _Config_getLocale() {
    // The following code is intended for client-side use only
    // to prevent server-side errors
    if (typeof window === 'undefined') {
        return DEFAULT_LOCALE;
    }
    const htmlTag = document.querySelector('html');
    const htmlLocale = htmlTag?.getAttribute('lang');
    if (!htmlLocale) {
        return DEFAULT_LOCALE;
    }
    if (ALLOWED_LOCALES.includes(htmlLocale)) {
        return htmlLocale;
    }
    const domains = document.location.hostname.split('.');
    const region = domains[domains.length - 1].toUpperCase();
    const localeWithRegion = ALLOWED_LOCALES.find((locale) => locale.includes(`${htmlLocale}-${region}`));
    const localeWithoutRegion = ALLOWED_LOCALES.find((locale) => locale.includes(htmlLocale));
    return localeWithRegion ?? localeWithoutRegion ?? DEFAULT_LOCALE;
};
export default Config;
